import React, { useState } from "react";
import { supabase } from "../supabaseClient";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: window.location.origin + "/set-password",
    });

    if (error) {
      setStatus({ type: "error", message: error.message });
    } else {
      setStatus({
        type: "success",
        message: "Email de resetare trimis. Verifică inbox-ul.",
      });
    }
    setLoading(false);
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <form
        onSubmit={handleReset}
        style={{ width: 360 }}
      >
        <h3 className="mb-3">Resetează parola</h3>
        <p className="text-muted" style={{ fontSize: 14 }}>
          Introdu adresa de email și îți trimitem un link pentru setarea unei parole noi.
        </p>

        <div className="mb-3">
          <label className="form-label">Email</label>
          <input
            type="email"
            className="form-control"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        {status && (
          <div
            className={
              status.type === "error" ? "alert alert-danger" : "alert alert-success"
            }
          >
            {status.message}
          </div>
        )}

        <button
          type="submit"
          className="btn btn-primary w-100"
          disabled={loading}
        >
          {loading ? "Se trimite..." : "Trimite link de resetare"}
        </button>
      </form>
    </div>
  );
}
